import React from "react";

import { Page, Text, View, Font, Image } from "@react-pdf/renderer";

import { useTranslation } from "react-i18next";

import openSans from "./fonts/OpenSans-Regular.ttf";
import openSansItalic from "./fonts/OpenSans-Italic.ttf";
import openSansBold from "./fonts/OpenSans-Bold.ttf";

import arial from "./fonts/ArialCE.ttf";
import arialItalic from "./fonts/ArialCEItalic.ttf";
import arialBold from "./fonts/ArialCEBold.ttf";

import ecpyTransparentLogo from "./images/ecpy.png";

import mentionsFr1 from "./images/CS-FR/Conditions-p1-Transport - Contrat V3.0_ECPY_FR_formulaire_rev.docx - copie.jpg";
import mentionsFr2 from "./images/CS-FR/Conditions-p2-Transport - Contrat V3.0_ECPY_FR_formulaire_rev.docx - copie.jpg";
import mentionsFr3 from "./images/CS-FR/Conditions-p3-Transport - Contrat V3.0_ECPY_FR_formulaire_rev.docx - copie.jpg";
import mentionsFr4 from "./images/CS-FR/Conditions-p4-Transport - Contrat V3.0_ECPY_FR_formulaire_rev.docx - copie.jpg";

import mentionsEn1 from "./images/CS-EN/Conditions-p1-Transport - Agreement V3.0_ECPY_EN_form with WatrMk&CopyRg.docx - copie.jpg";
import mentionsEn2 from "./images/CS-EN/Conditions-p2-Transport - Agreement V3.0_ECPY_EN_form with WatrMk&CopyRg.docx - copie.jpg";
import mentionsEn3 from "./images/CS-EN/Conditions-p3-Transport - Agreement V3.0_ECPY_EN_form with WatrMk&CopyRg.docx - copie.jpg";
import mentionsEn4 from "./images/CS-EN/Conditions-p4-Transport - Agreement V3.0_ECPY_EN_form with WatrMk&CopyRg.docx - copie.jpg";

import dayMentions1 from "./images/CJ-FR-EN/Conditions-p1-Transport - Contrat Journée- Day Agreement V3.0_ECPY_form.docx - copie.jpg";
import dayMentions2 from "./images/CJ-FR-EN/Conditions-p2-Transport - Contrat Journée- Day Agreement V3.0_ECPY_form.docx - copie.jpg";
import dayMentions3 from "./images/CJ-FR-EN/Conditions-p3-Transport - Contrat Journée- Day Agreement V3.0_ECPY_form.docx - copie.jpg";
import dayMentions4 from "./images/CJ-FR-EN/Conditions-p4-Transport - Contrat Journée- Day Agreement V3.0_ECPY_form.docx - copie.jpg";

import CharterMentions1 from "./images/CDC-EN-notices-P1.jpg";
import CharterMentions2 from "./images/CDC-EN-notices-P2.jpg";
import CharterMentions3 from "./images/CDC-EN-notices-P3.jpg";
import CharterMentions4 from "./images/CDC-EN-notices-P4.jpg";

import CharterMentions1fr from "./images/CDC-Mentions1-FR.jpg";
import CharterMentions2fr from "./images/CDC-Mentions2-FR.jpg";
import CharterMentions3fr from "./images/CDC-Mentions3-FR.jpg";
import CharterMentions4fr from "./images/CDC-Mentions4-FR.jpg";

import pdfStyles from "./views/ContractStyles";
import moment from "moment";

Font.register({
  family: "Open Sans",
  fonts: [
    {
      src: openSans,
    },
    {
      src: openSansItalic,
      fontStyle: "italic",
    },
    {
      src: openSansBold,
      fontWeight: 800,
    },
  ],
});

Font.register({
  family: "Arial",
  fonts: [
    {
      src: arial,
    },
    {
      src: arialItalic,
      fontStyle: "italic",
    },
    {
      src: arialBold,
      fontWeight: 800,
    },
  ],
});

export const ContractDocument = ({
  contract,
  jsonView,
  type,
  status,
  lang,
  user = null,
  codename,
  version,
  cfDate,
  isDay,
}) => {
  const { t } = useTranslation();
  const isPassengers = contract.template?.codeName === "passengers";
  const agreementDate = moment("2026-02-16").format("D MMMM YYYY");

  const extractFieldByName = (name) => {
    let field = null;

    for (let i in contract.fields) {
      if (contract.fields[i].name === name) {
        if (!field || (field && contract.fields[i].order < field.order)) {
          field = contract.fields[i];
        }
      }
    }

    return field;
  };

  const extractFieldValueByName = (name) => {
    let field = null;

    let savedIndex = null;

    for (let i in contract.fields) {
      if (contract.fields[i].name === name) {
        if (!field || (field && contract.fields[i].order < field.order)) {
          field = contract.fields[i];
          savedIndex = i;
        }
      }
    }

    // TODO : faire ça propre pour les champs à ne pas supprimer
    if (
      field &&
      savedIndex &&
      field.name !== "mainCurrency" &&
      field.name !== "currencyMain" &&
      field.name !== "addendumCurrency" &&
      field.name !== "client" &&
      field.name !== "serviceProvider" &&
      field.name !== "brokerName" &&
      field.name !== "centralAgent" &&
      field.name !== "stakeholder" &&
      field.name !== "agreementUniqueNumber"
    ) {
      delete contract.fields[savedIndex];
    }

    if (field) {
      // Checkbox cases
      if (field.value === "true") {
        return t(field.label);
      } else if (field.value === "false") {
        return "";
      }

      // default (text / date / radio / ...)
      return field.value;
    }

    return "";
  };

  const replaceVariables = (view, specialType = null) => {
    const locale = contract?.contractFolder?.lang || "en";

    const numberLocale = "en-US";
    const opts = { minimumFractionDigits: 2 };

    let updatedView = view;

    //const idToReplaceRegex = /(?<=__)[\S]*?(?=__)/g
    const idToReplaceRegex = /(?:__)([\S]*?)(?=__)/g;

    // Split while keeping the __placeholders__ (odd indexes) so translations
    // never alter a placeholder name (e.g. "to" => "au" in __agreement_term_to__)
    const splitRegex = /(__[\S]*?__)/g;
    const splitViewElements = updatedView.split(splitRegex);

    // Translate labels

    updatedView = splitViewElements
      .map((el, index) => {
        if (index % 2 === 1 || el === "") {
          return el;
        }

        let translatedEl = el;
        const splitted = el.split(/\s:\s/);

        for (let splitEl of splitted) {
          if (splitEl !== "") {
            const trimEl = splitEl.trim();

            const translated =
              contract.template?.codeName === "baseTemplateDay"
                ? trimEl
                : t(trimEl, { lng: locale });

            translatedEl = translatedEl.replaceAll(trimEl, translated);
          }
        }

        return translatedEl;
      })
      .join("");

    // Replace variables

    const idsToReplace = updatedView.match(idToReplaceRegex);

    if (idsToReplace) {
      for (let id of idsToReplace) {
        const goodId = id.substring(2);

        const replaceRegex = new RegExp(`__${goodId}__`, "g");

        let tempData = "";

        var fieldName = goodId;

        if (goodId === "clientAdresse1") {
          fieldName = "clientAddress1";
        }

        if (goodId === "clientAdresse2") {
          fieldName = "clientAddress2";
        }

        if (goodId === "clientAdresse3") {
          fieldName = "clientAddress3";
        }

        let field = extractFieldByName(fieldName);

        if (specialType && specialType === "display-everytime") {
          if (field) {
            tempData = t(field.label);
          }
        }

        let data = extractFieldValueByName(fieldName);
        if (data === "") {
          // If no data, replace with label
          data = tempData;
        }

        if (!isNaN(data) && !isNaN(parseFloat(data))) {
          if (field.formatNumber) {
            const nb = parseFloat(data);
            data = nb.toLocaleString(numberLocale, opts);
          }
        }

        if (data === "Invalid date") {
          data = "";
        }
        if (
          goodId === "additionalInsuranceLuggage" ||
          goodId === "additionalInsuranceAssistance" ||
          goodId === "additionalInsuranceCancellation"
        ) {
          data = t(data, { lng: locale });
        }

        updatedView = updatedView.replaceAll(replaceRegex, data);
      }
    }

    return updatedView;
  };
  // Hide empty instalment blocks at render time only: the json view is a shared
  // module object, mutating it would hide the block in every later PDF
  const isHiddenBlock = (node) => {
    if (node.name === "secondInstalmentBlock") {
      const field = extractFieldByName("secondInstalment");
      return !field || field.value === "";
    }

    if (node.name === "thirdInstalmentBlock") {
      const field = extractFieldByName("thirdInstalment");
      return !field || field.value === "";
    }

    return false;
  };
  const renderNode = (node, repeatedIndex = null) => {
    let ignoreField = false;

    if (!node) return null;

    if (node.type === "text") {
      let content = replaceVariables(node.content, node.specialType);
      if (repeatedIndex !== null) {
        content = node.content;
        content = content.replace("__index__", repeatedIndex + 1);
      }

      if ((node.content !== "" || node.renderBlank === true) && !ignoreField) {
        return (
          <Text style={node.styles ? node.styles : {}}>
            {content}
            {node.items && <> {renderItems(node.items, repeatedIndex)}</>}
          </Text>
        );
      }
    }

    // ✅ Si le nœud contient d'autres items
    if (node.items) {
      return renderItems(node.items, repeatedIndex);
    }

    return null;
  };

  const renderView = (item) => {
    let styles = item.styles ? item.styles : {};
    let items = item.items;

    if (item.specialType) {
      if (item.specialType === "checkbox") {
        let linkedFieldName = item.linkedField;
        let field = extractFieldByName(linkedFieldName);

        if (field && field?.value === "true") {
          if (linkedFieldName?.includes("additionalInsurance")) {
            styles = {
              ...styles,
              ...pdfStyles.smallCheckboxChecked,
            };
          } else {
            styles = {
              ...styles,
              ...pdfStyles.checkboxChecked,
              backgroundColor: "#000",
            };
          }
        }
      } else if (item.specialType === "choice") {
        items = [];

        let linkedFieldName = item.linkedField;
        let field = extractFieldByName(linkedFieldName);

        if (field) {
          let fieldValue = field.value;

          if (
            field.options &&
            field.options?.length &&
            field.options?.length > 0
          ) {
            for (let option of field.options) {
              let checkboxStyles = { ...pdfStyles.checkbox, fontSize: 6 };

              if (option === fieldValue) {
                checkboxStyles = {
                  ...checkboxStyles,
                  ...pdfStyles.checkboxChecked,
                };
              }

              let optionItem = {
                type: "view",
                styles: {
                  ...pdfStyles.checkboxWrapper,
                  marginRight: "5pt",
                },
                items: [
                  {
                    type: "view",
                    styles: {
                      ...checkboxStyles,
                    },
                    items: [],
                  },

                  {
                    type: "text",
                    styles: {
                      ...pdfStyles.textContent,
                      paddingTop: item.withPadding ? "3pt" : "0",
                    },
                    content: option,
                  },
                ],
              };

              items.push(optionItem);
            }
          }
        }
      }
    }

    return (
      <View
        style={styles}
        break={item.attrs && item.attrs.break ? true : false}
        wrap={item.attrs && item.attrs.wrap === false ? false : true}
      >
        {renderItems(items)}
      </View>
    );
  };

  const renderItems = (items, repeatedIndex = null) => {
    return items.filter((item) => !isHiddenBlock(item)).map((item, i) => (
      <React.Fragment key={i}>
        {item.type === "view" &&
          (item.repeated
            ? renderRepeatedViewItem(item)
            : renderView(item, repeatedIndex))}

        {item.type === "text" && renderNode(item, repeatedIndex)}
      </React.Fragment>
    ));
  };
  const renderRepeatedViewItem = (item) => {
    const nameToFind = item.findRepeated;
    let repeatNb = 0;

    for (let i in contract.fields) {
      if (contract.fields[i].name === nameToFind) {
        repeatNb++;
      }
    }

    return Array.from({ length: repeatNb }, (_, k) => (
      <View
        style={item.styles || {}}
        break={item.attrs?.break || false}
        wrap={isPassengers ? false : true}
        key={k}
      >
        {renderItems(item.items, k)}
      </View>
    ));
  };

  const renderFromJson = (json) => {
    if (json.type === "page") {
      return renderItems(json?.items);
    }
  };
  let agreementUniqueNumber = null;
  const renderTopInfos = () => {
    agreementUniqueNumber = extractFieldByName("agreementUniqueNumber");
    if (!agreementUniqueNumber) return null;

    const isSpecialTemplate = [
      "passengers",
      "rider",
      "addendum",
      "itinerary",
    ].includes(contract.template?.codeName);

    return (
      <>
        <View
          fixed
          style={{
            position: "absolute",
            top: 15,
            width: "80%",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Text style={{ fontSize: 6, left: 60 }}>
            {contract.contractFolder?.folderType === "transport"
              ? contract?.template?.codeName === "baseTemplateDay"
                ? t("ECPY day transport and services agreement for Yachts –")
                : t("ECPY transport and services agreement for Yachts – ")
              : t("Charter Agreement")}
            {type !== "charter" && `Version 4.0 - ${agreementDate}`}
          </Text>
        </View>

        <View
          fixed
          style={{
            position: "absolute",
            top: 15,
            right: 13,
            flexDirection: "row",
            alignItems: "center",
            gap: 8,
          }}
        >
          <Text
            fixed
            style={{
              fontFamily: "Roboto",
              fontWeight: "normal",
              fontSize: 8,
              right: 17,
            }}
            render={({ pageNumber }) =>
              pageNumber > 1 ? `N° ${agreementUniqueNumber?.value}` : ""
            }
          />

          <Text
            fixed
            style={{
              fontFamily: "Roboto",
              fontWeight: "normal",
              fontSize: 8,
            }}
            render={({ pageNumber }) =>
              `Page ${isSpecialTemplate ? pageNumber : pageNumber}`
            }
          />
        </View>
      </>
    );
  };

  return (
    <Page size="A4" style={pdfStyles.page}>
      {contract !== "legalMentions" && contract !== "legalMentionsFr" && (
        <Image
          fixed
          src={ecpyTransparentLogo}
          style={{
            width: 65,
            height: "auto",
            position: "absolute",
            top: 10,
            left: 0,
          }}
        />
      )}

      {renderTopInfos()}

      {contract !== "legalMentions" && contract !== "legalMentionsFr" && (
        <Text
          fixed
          style={{
            fontFamily: "Open Sans",
            fontSize: 96,
            color: "#000000",
            opacity: 0.3,
            transform: "rotate(-45deg)",
            position: "absolute",
            left: status === "draft" ? 0 : -120,
            top: 200,
            width: 1000,
            zIndex: 100,
          }}
        >
          {status === "draft"
            ? t("DRAFT", { lng: lang })
            : t("ECPY Copyright", { lng: lang })}
        </Text>
      )}

      {contract.template?.codeName === "baseTemplateDay" &&
        contract.template !== undefined && (
          <View
            fixed
            style={{
              position: "absolute",
              bottom: 15,
              left: 65,
              display: "flex",
              flexDirection: "row",
            }}
          >
            <View style={{ width: "30%" }}>
              <Text
                style={{
                  ...pdfStyles.textContent,
                  fontSize: 7,
                }}
              >
                {t("VEUILLEZ PARAPHER")}
              </Text>

              {
                <Text
                  style={{
                    ...pdfStyles.textContent,
                    fontSize: 7,
                    fontFamily: "Helvetica-Oblique",
                    marginTop: 0,
                  }}
                >
                  {t("PLEASE INITIAL")}
                </Text>
              }
            </View>

            <View style={{ width: "30%" }}>
              <Text
                style={{
                  ...pdfStyles.textContent,
                  fontSize: 7,
                }}
              >
                {t("PROPRIETAIRE")} _{" "}
              </Text>
              {
                <Text
                  style={{
                    ...pdfStyles.textContent,
                    fontSize: 7,
                    fontFamily: "Helvetica-Oblique",
                    marginTop: 0,
                  }}
                >
                  {t("SERVICE PROVIDER")}
                </Text>
              }
            </View>

            <View style={{ width: "30%" }}>
              <Text
                style={{
                  ...pdfStyles.textContent,
                  fontSize: 7,
                }}
              >
                {t("AFFRÉTEUR")} __
              </Text>
              {
                <Text
                  style={{
                    ...pdfStyles.textContent,
                    fontSize: 7,
                    fontFamily: "Helvetica-Oblique",
                    marginTop: 0,
                  }}
                >
                  {t("CLIENT")}
                </Text>
              }
            </View>
          </View>
        )}

      {!isDay && (
        <Text
          fixed
          style={{
            fontFamily: "Open Sans",
            fontSize: 8,
            fontStyle: "italic",
            color: "#203f80",
            transform: "rotate(-90deg)",
            position: "absolute",
            top: 400,
            right:
              contract.template?.codeName === "baseTemplateDay" ? 170 : 180,
            width: 800,
          }}
        >
          {contract !== "legalMentions" &&
            contract !== "legalMentionsFr" &&
            t(
              "This Agreement is the property of ECPY. Any reproduction, in part or in full, any distribution or use without the formal agreement in writing of this Association is strictly forbidden. All rights reserved.",
              {
                lng:
                  contract.template?.codeName === "baseTemplateDay"
                    ? "en"
                    : contract.contractFolder?.lang,
              },
            )}
        </Text>
      )}

      {isDay && (
        <Text
          fixed
          style={{
            fontFamily: "Open Sans",
            fontSize: 8,
            fontStyle: "italic",
            color: "#203f80",
            position: "absolute",
            top: 400,
            width: 700,
            writingDirection: "ltr",
            transform: "rotate(-90deg)",
            right: 210,
          }}
        >
          Ce contrat est la propriété de ECPY. Toute reproduction, partielle ou
          complète, toute diffusion ou utilisation sans l’accord exprès et par
          écrit de l’association est strictement interdite.Tous droits réservés.
          This Agreement is the property of ECPY. Any reproduction, in part or
          in full, any distribution or use without the formal agreement in
          writing of this association is strictly forbidden. All rights
        </Text>
      )}
      {/* {(contract === "legalMentions" || contract === "legalMentionsFr") && (
        <>
          <View
            fixed
            style={{
              position: "absolute",
              top: 15,
              width: "80%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text style={{ fontSize: 6, left: 60 }}>
              {type !== "charter"
                ? isDay
                  ? "ECPY day transport and services agreement for Yachts – "
                  : "ECPY transport and services agreement for Yachts – "
                : "Charter agreement"}
              {`Version ${version}.0 - ${moment(cfDate).format("D MMMM YYYY")}`}
            </Text>
          </View>
          {isDay && (
            <View
              fixed
              style={{
                position: "absolute",
                top: 15,
                right: 13,
                flexDirection: "row",
                alignItems: "center",
                gap: 8,
              }}
            >
              <Text
                fixed
                style={{
                  fontFamily: "Roboto",
                  fontWeight: "normal",
                  fontSize: 8,
                }}
                render={({ pageNumber }) => `Page ${pageNumber}`}
              />
            </View>
          )}
        </>
      )} */}
      {contract === "legalMentions" || contract === "legalMentionsFr" ? (
        <>
          {contract === "legalMentions" &&
          type !== "charter" &&
          codename !== "baseTemplateDay" ? (
            <>
              <View>
                <Image
                  src={mentionsEn1}
                  style={{
                    width: 600,
                    height: 830,
                    alignSelf: "center",
                    marginRight: 20,
                  }}
                />
                <Image
                  src={mentionsEn2}
                  style={{
                    width: 600,
                    height: 830,
                    alignSelf: "center",
                    marginRight: 20,
                  }}
                />
                <Image
                  src={mentionsEn3}
                  style={{
                    width: 600,
                    height: 830,
                    alignSelf: "center",
                    marginRight: 20,
                  }}
                />
                <Image
                  src={mentionsEn4}
                  style={{
                    width: 600,
                    height: 830,
                    alignSelf: "center",
                    marginRight: 20,
                  }}
                />
                <>
                  <View
                    fixed
                    style={{
                      position: "absolute",
                      top: 15,
                      width: "80%",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Text style={{ fontSize: 6, left: 0 }}>
                      {type !== "charter"
                        ? isDay
                          ? `ECPY day transport and services agreement for Yachts – Version 4.0 - ${agreementDate}`
                          : `ECPY transport and services agreement for Yachts – Version 4.0 - ${agreementDate}`
                        : "Charter agreement"}
                    </Text>
                  </View>
                  <View
                    fixed
                    style={{
                      position: "absolute",
                      top: 15,
                      right: 13,
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <Text
                      fixed
                      style={{
                        fontFamily: "Roboto",
                        fontWeight: "normal",
                        fontSize: 8,
                      }}
                      render={({ pageNumber }) => `Page ${pageNumber}`}
                    />
                  </View>
                </>
                <Text
                  fixed
                  style={{
                    fontFamily: "Open Sans",
                    fontSize: 96,
                    color: "#000000",
                    opacity: 0.3,
                    transform: "rotate(-45deg)",
                    position: "absolute",
                    left: status === "draft" ? -30 : -170,
                    top: 200,
                    width: 1000,
                    zIndex: 100,
                  }}
                >
                  {status === "draft"
                    ? t("DRAFT", { lng: lang })
                    : t("ECPY Copyright", { lng: lang })}
                </Text>
              </View>
            </>
          ) : contract === "legalMentionsFr" &&
            type !== "charter" &&
            codename !== "baseTemplateDay" ? (
            <View>
              <Image
                src={mentionsFr1}
                style={{
                  width: 600,
                  height: 830,
                  alignSelf: "center",
                  marginRight: 20,
                }}
              />
              <Image
                src={mentionsFr2}
                style={{
                  width: 600,
                  height: 830,
                  alignSelf: "center",
                  marginRight: 20,
                }}
              />
              <Image
                src={mentionsFr3}
                style={{
                  width: 600,
                  height: 830,
                  alignSelf: "center",
                  marginRight: 20,
                }}
              />
              <Image
                src={mentionsFr4}
                style={{
                  width: 600,
                  height: 830,
                  alignSelf: "center",
                  marginRight: 20,
                }}
              />
              <>
                <View
                  fixed
                  style={{
                    position: "absolute",
                    top: 15,
                    width: "80%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Text style={{ fontSize: 6, left: 0 }}>
                    {type !== "charter"
                      ? isDay
                        ? `ECPY day transport and services agreement for Yachts – Version 4.0 - ${agreementDate}`
                        : `ECPY transport and services agreement for Yachts – Version 4.0 - ${agreementDate}`
                      : "Charter agreement"}
                  </Text>
                </View>
                <View
                  fixed
                  style={{
                    position: "absolute",
                    top: 15,
                    right: 13,
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <Text
                    fixed
                    style={{
                      fontFamily: "Roboto",
                      fontWeight: "normal",
                      fontSize: 8,
                    }}
                    render={({ pageNumber }) => `Page ${pageNumber}`}
                  />
                </View>
              </>
              <Text
                fixed
                style={{
                  fontFamily: "Open Sans",
                  fontSize: 96,
                  color: "#000000",
                  opacity: 0.3,
                  transform: "rotate(-45deg)",
                  position: "absolute",
                  left: status === "draft" ? -30 : -170,
                  top: 200,
                  width: 1000,
                  zIndex: 100,
                }}
              >
                {status === "draft"
                  ? t("DRAFT", { lng: lang })
                  : t("ECPY Copyright", { lng: lang })}
              </Text>
            </View>
          ) : type !== "charter" ? (
            <View>
              <Image
                src={dayMentions1}
                style={{
                  width: 600,
                  height: 830,
                  alignSelf: "center",
                  marginRight: 20,
                }}
              />
              <Image
                src={dayMentions2}
                style={{
                  width: 600,
                  height: 830,
                  alignSelf: "center",
                  marginRight: 20,
                }}
              />
              <Image
                src={dayMentions3}
                style={{
                  width: 600,
                  height: 830,
                  alignSelf: "center",
                  marginRight: 20,
                }}
              />
              <Image
                src={dayMentions4}
                style={{
                  width: 600,
                  height: 830,
                  alignSelf: "center",
                  marginRight: 20,
                }}
              />
              <>
                <View
                  fixed
                  style={{
                    position: "absolute",
                    top: 15,
                    width: "80%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Text style={{ fontSize: 6, left: 0 }}>
                    {"ECPY day transport and services agreement for Yachts – "}
                    {`Version 4.0 - ${agreementDate}`}
                  </Text>
                </View>
                <View
                  fixed
                  style={{
                    position: "absolute",
                    top: 15,
                    right: 13,
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <Text
                    fixed
                    style={{
                      fontFamily: "Roboto",
                      fontWeight: "normal",
                      fontSize: 8,
                    }}
                    render={({ pageNumber }) => `Page ${pageNumber}`}
                  />
                </View>
              </>
              <Text
                fixed
                style={{
                  fontFamily: "Open Sans",
                  fontSize: 96,
                  color: "#000000",
                  opacity: 0.3,
                  transform: "rotate(-45deg)",
                  position: "absolute",
                  left: status === "draft" ? -30 : -170,
                  top: 200,
                  width: 1000,
                  zIndex: 100,
                }}
              >
                {status === "draft"
                  ? t("DRAFT", { lng: lang })
                  : t("ECPY Copyright", { lng: lang })}
              </Text>
            </View>
          ) : (
            <View>
              <Image
                src={lang === "fr" ? CharterMentions1fr : CharterMentions1}
                style={{ marginTop: 25 }}
              />
              <Image
                src={lang === "fr" ? CharterMentions2fr : CharterMentions2}
                style={{ marginTop: 25 }}
              />

              <Image
                src={lang === "fr" ? CharterMentions3fr : CharterMentions3}
                style={{ marginTop: 25 }}
              />
              <Image
                src={lang === "fr" ? CharterMentions4fr : CharterMentions4}
                style={{ marginTop: 25 }}
              />
              <Text
                fixed
                style={{
                  fontFamily: "Open Sans",
                  fontSize: 96,
                  color: "#000000",
                  opacity: 0.25,
                  transform: "rotate(-45deg)",
                  position: "absolute",
                  left: status === "draft" ? -30 : -170,
                  top: 200,
                  width: 1000,
                  zIndex: 100,
                }}
              >
                {status === "draft"
                  ? t("DRAFT", { lng: lang })
                  : t("ECPY Copyright", { lng: lang })}
              </Text>
            </View>
          )}
        </>
      ) : (
        <>{renderFromJson(jsonView)}</>
      )}
    </Page>
  );
};
